(function () {
  var header = document.querySelector('[data-jelly-header]');
  var burger = document.querySelector('[data-burger]');
  var menuPanel = document.querySelector('[data-menu-panel]');
  var overlay = document.querySelector('[data-overlay]');
  var searchBar = document.querySelector('[data-search-bar]');
  if (!header || !burger || !menuPanel || !overlay || !searchBar) return;

  function openMenu() {
    burger.classList.add('open');
    burger.setAttribute('aria-expanded', 'true');
    menuPanel.classList.add('open');
    overlay.classList.add('show');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    burger.classList.remove('open');
    burger.setAttribute('aria-expanded', 'false');
    menuPanel.classList.remove('open');
    overlay.classList.remove('show');
    document.body.style.overflow = '';
  }
  burger.addEventListener('click', function () {
    menuPanel.classList.contains('open') ? closeMenu() : openMenu();
  });
  var menuClose = document.querySelector('[data-menu-close]');
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  overlay.addEventListener('click', function () {
    closeMenu();
    closeSearch();
  });

  var bagsToggle = document.querySelector('[data-bags-toggle]');
  var bagsSubmenu = document.querySelector('[data-bags-submenu]');
  var bagsArrow = document.querySelector('[data-bags-arrow]');
  if (bagsToggle && bagsSubmenu && bagsArrow) {
    bagsToggle.addEventListener('click', function () {
      bagsSubmenu.classList.toggle('open');
      bagsArrow.classList.toggle('open');
    });
  }

  function openSearch() {
    searchBar.classList.add('open');
    overlay.classList.add('show');
    setTimeout(function () {
      var input = searchBar.querySelector('.search-input');
      if (input) input.focus();
    }, 300);
  }
  function closeSearch() {
    searchBar.classList.remove('open');
    if (!menuPanel.classList.contains('open')) overlay.classList.remove('show');
  }
  var searchOpenBtn = document.querySelector('[data-search-open]');
  var searchCloseBtn = document.querySelector('[data-search-close]');
  if (searchOpenBtn) searchOpenBtn.addEventListener('click', openSearch);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
      closeSearch();
    }
  });

  window.addEventListener(
    'scroll',
    function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    },
    { passive: true }
  );

  document.addEventListener('cart:updated', function (e) {
    var count = document.querySelector('[data-cart-count]');
    if (count && e.detail && typeof e.detail.itemCount === 'number') {
      count.textContent = e.detail.itemCount;
    }
  });
})();
